import React from 'react';
import { Container, Stack } from '@grubhubprod/gh-cookbook-react';
import Table from 'src/components/Table/Table';
import { NoResultsMsg } from 'src/components/Table/NoResultsMsg';
import { TieredAccountTableHeaderRow } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountTableHeaderRow/TieredAccountTableHeaderRow';
import { FIVE_ROW_HEIGHT } from 'src/components/enterprise/Parents/constants';

export interface AccountsTableProps {
  children: React.ReactNode;
  numberOfAccounts: number;
  noResultsMsg?: string;
  headers: string[];
  scrollable?: boolean;
  isLoading?: boolean;
}

export const TieredAccountsTable: React.FC<AccountsTableProps> = ({
  children,
  numberOfAccounts,
  noResultsMsg = 'No results found',
  headers,
  scrollable = true,
  isLoading = false,
}) => {
  const displayNoAccountsMessage = <NoResultsMsg message={noResultsMsg} />;

  return (
    <Container>
      <Stack>
        <Table
          headerInsets="none"
          bodyMaxHeight={scrollable ? FIVE_ROW_HEIGHT : null}
          header={() => <TieredAccountTableHeaderRow headers={headers} />}
          body={() =>
            numberOfAccounts > 0 ? children : displayNoAccountsMessage
          }
          showFooter={false}
          isLoading={isLoading}
        />
      </Stack>
    </Container>
  );
};
